import React from 'react';
import { Alert, AlertTitle, Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface DeletedResourceNoticeProps {
  title: string;
  message: string;
  backLabel?: string;
  backTo?: string;
}

const DeletedResourceNotice: React.FC<DeletedResourceNoticeProps> = ({
  title,
  message,
  backLabel = 'Go back',
  backTo = '/batches',
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        width: '100%',
        minHeight: '100%',
        p: 3,
      }}
    >
      <Stack spacing={2.5} sx={{ maxWidth: 520, width: '100%', textAlign: 'center' }}>
        <Alert
          severity="warning"
          variant="outlined"
          sx={{
            borderRadius: 1.5,
            alignItems: 'flex-start',
            bgcolor: (theme) => theme.palette.warning.main + '08',
            '& .MuiAlert-message': { width: '100%' },
          }}
        >
          <AlertTitle sx={{ fontWeight: 700, mb: 0.5 }}>{title}</AlertTitle>
          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>
        </Alert>
        <Button
          variant="contained"
          disableElevation
          onClick={() => navigate(backTo)}
          sx={{ alignSelf: 'center', minWidth: 200 }}
        >
          {backLabel}
        </Button>
      </Stack>
    </Box>
  );
};

export default DeletedResourceNotice;
